// Structure « étude de marché » (même mécanique que web/francia/src/lib/toc.ts) : parties → sous-parties,
// numérotées, avec ancre (id) et clé i18n. Le sommaire et les titres lisent la même structure.
import type { Pays } from './pays';

export interface TocItem { id: string; key: string; children?: TocItem[] }

export function numberOf(items: TocItem[], id: string): string {
  for (let i = 0; i < items.length; i++) {
    const it = items[i];
    if (it.id === id) return String(i + 1);
    const ch = it.children || [];
    for (let j = 0; j < ch.length; j++) if (ch[j].id === id) return (i + 1) + '.' + (j + 1);
  }
  return '';
}

export function flatIds(items: TocItem[]): string[] {
  const out: string[] = [];
  for (const it of items) { out.push(it.id); for (const c of it.children || []) out.push(c.id); }
  return out;
}

// Même plan que l'étude France (22/10/2026), vu du pays importateur : les marchés deviennent les pays
// d'origine, les régions françaises les États brésiliens (avec la voie de transport) ou les ports d'entrée
// américains. Avec une origine choisie, 4.1 devient « Place de ce pays » et 5.3 « États / ports de ce pays ».
export function regId(p: Pays) { return p === 'bra' ? 'estados' : 'puertos'; }

export function etudeToc(p: Pays, origin: boolean): TocItem[] {
  const r = regId(p);
  return [
    { id: 'resumen', key: 'toc.resumen' },
    { id: 'evolucion', key: 'toc.evolucion', children: [
      { id: 'valor-volumen-precio', key: 'toc.vvp' },
      { id: 'mes-a-mes', key: 'toc.mes' },
    ] },
    { id: 'vinos', key: 'toc.vinos', children: [
      { id: 'tipos', key: 'toc.tipos' },
      { id: 'espumosos', key: 'toc.spark' },
      { id: 'tipos-evolucion', key: 'toc.tiposEvo' },
    ] },
    { id: 'origenes', key: 'toc.origenes', children: [
      { id: 'primeros-origenes', key: origin ? 'toc.origPlace' : 'toc.origTop' },
      { id: 'lo-que-se-mueve', key: 'toc.mueve' },
      { id: 'zonas', key: 'toc.zonas' },
    ] },
    { id: r, key: 'toc.reg', children: [
      { id: 'mapa-' + r, key: 'toc.mapa' },
      { id: r + '-evolucion', key: 'toc.regEvo' },
      { id: r + '-origenes', key: origin ? 'toc.regOrigSel' : 'toc.regOrig' },
      ...(p === 'bra' ? [{ id: 'transporte', key: 'toc.transporte' }] : []),
    ] },
    { id: 'mundo', key: 'toc.mundo', children: [
      { id: 'importadores', key: 'toc.importadores' },
      { id: 'peso-proveedores', key: 'toc.peso' },
    ] },
    { id: 'metodologia', key: 'toc.metodo' },
  ];
}
